import { UpdatedField } from '../../typescript-types/employee-change-log';

import { formatDate, formatPhoneNumber } from '../../util/formatters';
import { LANGUAGES } from '../../util/languages';

const formatValue = (value: any, formatAs: 'YES_NO' | 'DATE' | 'PHONE') => {
  switch (formatAs) {
    case 'YES_NO':
      return value ? 'Yes' : 'No';
    case 'DATE':
      return value ? formatDate(value.toString()) : '';
    case 'PHONE':
      return value ? formatPhoneNumber(value) : '';
    default:
      return value || '';
  }
};

export const getValueChanges = (
  changedValues: { [field: string]: UpdatedField<any> | undefined },
  orgsInAccount: Org[],
) => {
  const changes: Array<{ field: string; newValue: any; oldValue: any }> = [];
  Object.entries(changedValues || {}).forEach(([field, values]) => {
    if (!values?.newValue && !values?.oldValue) {
      return;
    }

    // When adding a new field case to this function, look at updating the summary section of HrisEmployeeDiffTableChangesCell
    if (['jobTitle', 'nickname', 'firstName', 'lastName', 'email', 'externalId'].includes(field)) {
      changes.push({ field, newValue: values?.newValue, oldValue: values?.oldValue });
    } else if (['phoneNumber'].includes(field)) {
      changes.push({
        field,
        newValue: formatValue(values?.newValue, 'PHONE'),
        oldValue: formatValue(values?.oldValue, 'PHONE'),
      });
    } else if (field === 'languagePreference') {
      changes.push({
        field,
        newValue: LANGUAGES[values?.newValue],
        oldValue: LANGUAGES[values?.oldValue],
      });
    } else if (['startDate', 'endDate', 'birthdate'].includes(field)) {
      changes.push({
        field,
        newValue: formatValue(values?.newValue, 'DATE'),
        oldValue: formatValue(values?.oldValue, 'DATE'),
      });
    } else if (
      ['optedOutOfTexts', 'endReasonId'].includes(field) &&
      Boolean(values?.newValue) !== Boolean(values?.oldValue)
    ) {
      changes.push({
        field: field === 'endReasonId' ? 'markedAsTerminated' : field,
        newValue: formatValue(values?.newValue, 'YES_NO'),
        oldValue: formatValue(values?.oldValue, 'YES_NO'),
      });
    } else if (field === 'orgId') {
      changes.push({
        field: 'Organization',
        newValue: orgsInAccount.find((o) => o.org_id === values?.newValue)?.name,
        oldValue: orgsInAccount.find((o) => o.org_id === values?.oldValue)?.name,
      });
    }
  });
  return changes;
};
